import { render, staticRenderFns } from "./ProductcenterPDRHeaView.vue?vue&type=template&id=7ca18038&scoped=true"
import script from "./ProductcenterPDRHeaView.vue?vue&type=script&lang=js"
export * from "./ProductcenterPDRHeaView.vue?vue&type=script&lang=js"
import style0 from "./ProductcenterPDRHeaView.vue?vue&type=style&index=0&id=7ca18038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca18038",
  null
  
)

export default component.exports